import { SVGProps } from 'react';

export function SidebarCloseIcon({
  fill = 'currentColor',
  size = 18,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path d="M15.75 4.5V6H8.25V4.5H15.75Z" fill={fill ?? '#DFE2E7'} />
      <path
        d="M4.93681 9.75H15.75V8.25H4.93681L6.75 6.3075L5.76014 5.25L2.25 9L5.76014 12.75L6.75 11.6925L4.93681 9.75Z"
        fill={fill ?? '#DFE2E7'}
      />
      <path d="M8.25 13.5H15.75V12H8.25V13.5Z" fill={fill ?? '#DFE2E7'} />
    </svg>
  );
}
